/**
 * Signup step meta — total is 4 when profile fields exist, else 3.
 */
type FieldLike = {
  visible?: boolean;
  isOnboarding?: boolean;
  required?: boolean;
  fieldId?: { fieldName?: string; isOnboarding?: boolean };
  field?: { fieldName?: string; isOnboarding?: boolean };
};

export function countOnboardingFields(payload: unknown): number {
  const selected =
    (payload as { data?: { selectedFields?: FieldLike[] } })?.data
      ?.selectedFields ?? [];

  return selected.filter((item) => {
    const field = item?.fieldId || item?.field;
    if (!field?.fieldName) return false;
    if (item?.visible === false) return false;
    if (item?.isOnboarding === false || field.isOnboarding === false) return false;
    return true;
  }).length;
}

export function hasSignupProfileStep(payload: unknown): boolean {
  return countOnboardingFields(payload) > 0;
}

export function getSignupSteps(hasProfileFields: boolean) {
  const totalSteps = hasProfileFields ? 4 : 3;
  return {
    totalSteps,
    signup: 1,
    otp: 2,
    profile: hasProfileFields ? 3 : null,
    password: hasProfileFields ? 4 : 3,
  } as const;
}
